import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeafletTileLayerComponent } from './leaflet-tile-layer.component';

@NgModule({
  declarations: [LeafletTileLayerComponent],
	exports: [LeafletTileLayerComponent],
  imports: [
    CommonModule
  ]
})
export class LeafletTileLayerModule { }
